module.exports = __webpack_public_path__ + "img/gal_34.3d87ae68.png";